import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled } from '@mui/material/styles';

export const CampusListItemWrapper = styled('div')(({ theme }) => ({
    border: '1px solid #E3E3E3',
    borderRadius: 10,
    boxShadow: '0px 0px 8px rgba(131, 131, 131, 0.3)',
    '&.borderHover:hover': {
        border: `1px solid ${theme.legacy.colors.neutralGrey75}`,
    },
}));

export const ListItemContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    padding: '24px 16px 16px',
    height: '100%',
    [theme.breakpoints.up('md')]: {
        flexDirection: 'column',
    },
}));

export const ListItemText = styled('div')({
    flex: 1,
});

export const ListItemHeader = styled(GivelifyLabel)({
    marginBottom: 8,
});

export const ListItemAction = styled('div')(({ theme }) => ({
    alignSelf: 'end',
    [theme.breakpoints.up('md')]: {
        marginTop: 32,
        alignSelf: 'end',
    },
}));

const baseChipStyles = (theme) => ({
    borderRadius: 20,
    padding: theme.spacing('3px', '8px'),
    color: theme.legacy.colors.neutralGrey,
});

export const YourCampusChip = styled('div')(({ theme }) => ({
    ...baseChipStyles(theme),
    backgroundColor: '#DCF1E5',
}));

export const AccountClaimedChip = styled('div')(({ theme }) => ({
    ...baseChipStyles(theme),
    backgroundColor: 'rgba(202, 210, 219, 0.3)',
}));
